export const buttonShadow = () => `
  box-shadow: 0 15px 20px -15px rgba(0, 0, 0, 0.20);
`

export const callToActionShadow = () => `
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.2);
`

export const cardShadow = () => `
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
`
